"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemesFromOptions = exports.validateOptions = exports.defaultThemeName = void 0;
const just_unique_1 = __importDefault(require("just-unique"));
exports.defaultThemeName = '__default';
/**
 * @param options
 * @throws an {@link Error} if the options are invalid
 */
const validateOptions = ({ defaultTheme, themes = [] }) => {
    var _a;
    if (themes.some(x => !x.name)) {
        throw new Error('Every theme in the themes array in the multiThemePlugin options must have a name property set to a unique string');
    }
    const names = themes.map(x => x.name);
    if ((0, just_unique_1.default)(names).length != names.length) {
        throw new Error('Every theme in the themes array in the multiThemePlugin options must have a unique name');
    }
    if (themes.some(x => x.name === exports.defaultThemeName)) {
        throw new Error(`No theme in the themes array in the multiThemePlugin options cannot have a name of "${exports.defaultThemeName}"`);
    }
    if (defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.selectors) {
        throw new Error('The default theme cannot have any selectors');
    }
    if (defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.mediaQuery) {
        throw new Error('The default theme cannot have a media query');
    }
    const darkTheme = themes.find(x => x.name === 'dark');
    if (darkTheme === null || darkTheme === void 0 ? void 0 : darkTheme.selectors) {
        throw new Error('Tailwind configures "dark" theme automatically which prevents any attempt to use custom selectors. This is a limitation of tailwind, not tailwindcss-themer. Please rename your "dark" theme to something else or remove the "selectors" field from your "dark" theme.');
    }
    if ((darkTheme === null || darkTheme === void 0 ? void 0 : darkTheme.mediaQuery) || ((_a = darkTheme === null || darkTheme === void 0 ? void 0 : darkTheme.mediaQuery) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        throw new Error('Tailwind configures "dark" theme automatically which prevents any attempt to use a custom media query. This is a limitation of tailwind, not tailwindcss-themer. Please rename your "dark" theme to something else or remove the "mediaQuery" field from your "dark" theme.');
    }
};
exports.validateOptions = validateOptions;
/**
 * @param options
 * @return the theme options reduced down to an array of themes
 * @throws an {@link Error} if the options are invalid
 */
const getThemesFromOptions = (options) => {
    (0, exports.validateOptions)(options);
    const { defaultTheme, themes = [] } = options;
    return [
        {
            extend: {},
            ...defaultTheme,
            name: exports.defaultThemeName
        },
        ...themes.map(x => ({ ...{ extend: {} }, ...x }))
    ];
};
exports.getThemesFromOptions = getThemesFromOptions;
